import App from './index.js';
import { isEmpty } from 'lodash';
import { amplitudeEvents } from './amplitude';
import Chart from 'chart.js/auto';
import select2 from 'select2';

select2(window, $);

App.BotAnalytics = (function () {
    let lastTrainingItemChecked = null;
    const organizationId = window.AMPLITUDE_BOOT?.organization_id || null;
    const apptegyClientId = window.AMPLITUDE_BOOT?.apptegy_client_id || null;
    const botId = window.AMPLITUDE_BOOT?.bot_id || null;
    const amplitude = amplitudeEvents();

    function lineGraphInit () {
        let el = $('#lineGraph');

        const labels = el.data('labels') || [];
        const datasets = el.data('datasets') || [];

        const data = {
            labels: labels,
            datasets: datasets
        };

        const config = {
            type: 'line',
            data: data,
            responsive: true,
            maintainAspectRatio: false,

            options: {
                plugins: {
                    legend: {
                        align: 'end',
                        labels: {
                            padding: 20,
                            boxWidth: 10,
                            boxHeight: 10,
                        }
                    },
                },
                scales: {
                    y: {
                        suggestedMax: 10
                    }
                }
            }
        };

        if (labels.length && datasets.length) {
            new Chart(
                el,
                config
            );
        }
    }

    function circleGraph () {
        let el = $('#circularGraph');

        const labels = el.data('labels') || [];
        const datasets = el.data('datasets') || [];

        const data = {
            labels: labels,
            datasets: datasets
        };

        const config = {
            type: 'doughnut',
            data: data,
            options: {
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            label: function ( context ) {
                                return context.label + ': ' + context.formattedValue + '%';
                            }
                        }
                    }
                }
            }
        };

        if (labels.length && datasets.length) {
            new Chart(
                el,
                config
            );
        }
    }

    function circularSessionsPerLanguagesGraph () {
        let el = $('#circularSessionsPerLanguagesGraph');

        const labels = el.data('labels') || [];
        const datasets = el.data('datasets') || [];

        const data = {
            labels: labels,
            datasets: datasets
        };

        const config = {
            type: 'doughnut',
            data: data,
            options: {
                plugins: {
                    legend: {
                        align: 'end',
                        labels: {
                            padding: 20,
                            boxWidth: 15,
                            boxHeight: 15,
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: function ( context ) {
                                return context.label + ': ' + context.formattedValue + '%';
                            }
                        }
                    }
                }
            }
        };

        if (labels.length && datasets.length) {
            new Chart(
                el,
                config
            );
        }
    }

    function initDatePicker () {
        $('#start_date').on('change', function ( e ) {
            var startDate = $(this).val();
            $('#end_date').attr('min', startDate);
        });
    }

    function assignToAnAnswer () {
        var text = $(this).data('text');
        $('#display_text').html(text);
        $('#assignQuestion [name="question"]').val(text);
        $('#assignQuestion').modal('show');
    }

    function initPopupTraining () {
        App.wysiwygEditor('#new_answer', 200, function ( data ) {

        });

        $('#bot_item_id').select2({
            theme: "bootstrap-5",
            dropdownParent: $("#existing_question")
        })
    }

    function toggleTrainingOptions () {
        $('.existing-question, .new-bot-item').toggleClass('d-none');
    }

    function submitTraining ( e ) {
        e.preventDefault();

        var elForm = $(this);
        if (elForm.find('[name="is_existing"]').is(':checked')) {
            if (isEmpty(elForm.find('[name="bot_item_id"]').val())) {
                elForm.find('.existing-question .invalid-feedback').remove();
                elForm.find('.existing-question').append(`
                   <span class="invalid-feedback d-block" role="alert">
                    <strong>Please select an existing item.</strong>
                </span>`);

                return false;
            }
        } else {
            if (isEmpty(elForm.find('[name="category"]').val())) {
                elForm.find('.category-holder .invalid-feedback').remove();
                elForm.find('.category-holder').append(`
                   <span class="invalid-feedback d-block" role="alert">
                    <strong>Category is required.</strong>
                </span>`);

                return false;
            }

            if (isEmpty(elForm.find('[name="new_answer"]').val())) {
                elForm.find('.new-answer .invalid-feedback').remove();
                elForm.find('.new-answer').append(`
                   <span class="invalid-feedback d-block" role="alert">
                    <strong>Answer is required.</strong>
                </span>`);

                return false;
            }
        }

        elForm[0].submit();
    }

    function deleteQuestion () {
        let text = $(this).data('text'),
            botItemId = $(this).data('bot-item-id'),
            elModal = $('#deleteQuestion');

        elModal.find('.questions-form-group').html('<input type="hidden" class="form-control" name="text" value="' + text + '"><input type="hidden" class="form-control" name="bot_item_id" value="' + botItemId + '">');
        elModal.find('.header-sub-text').html(`Are you sure you want to delete <strong>"${ text }"</strong>?`);
        elModal.modal('show');
    }

    function deleteTrainingPhrase () {
        let text = $(this).data('text'),
            elModal = $('#deleteTrainingPhrase'),
            botId = $(this).closest('tr').data('bot-id');

        elModal.find('.questions-form-group').html('<input type="hidden" class="form-control" name="bot_id[]" value="' + botId + '"><input type="hidden" class="form-control" name="questions[]" value="' + text + '">');
        elModal.find('.header-sub-text').html(`Are you sure you want to delete <strong>"${ text }"</strong>?`);
        elModal.modal('show');
    }

    function emailReportButton() {
        let elModal = $('#emailReportModal');
        elModal.modal('show');
    }

    function deleteAnswerFeedback () {
        let text = $(this).data('text'),
            id = $(this).data('id'),
            elModal = $('#deleteAnswerFeedback');

        elModal.find('.feedback-form-group').html('<input type="hidden" class="form-control" name="ids[]" value="' + id + '">');
        elModal.find('.header-sub-text').html(`Are you sure you want to delete <strong>"${ text }"</strong>?`);
        elModal.modal('show');
    }

    function omitTrainingPhrase () {
        let text = $(this).data('text'),
            elModal = $('#deleteTrainingPhrase'),
            botId = $(this).closest('tr').data('bot-id');

        elModal.find('.questions-form-group').html('<input type="hidden" class="form-control" name="bot_id[]" value="' + botId + '"><input type="hidden" class="form-control" name="omit" value="1"><input type="hidden" class="form-control" name="questions[]" value="' + text + '">');
        elModal.find('.header-sub-text').html(`Are you sure you want to omit <strong>"${ text }"</strong>?`);
        elModal.modal('show');
    }

    function deleteBulkTrainingPhrase () {
        let text = $(this).data('text'),
            elModal = $('#deleteTrainingPhrase');

        $('.select-training-phrases:checked').each(function () {
            let botId = $(this).closest('tr').data('bot-id')
            elModal.find('.questions-form-group').append('<input type="hidden" class="form-control" name="bot_id[]" value="' + botId + '"><input type="hidden" class="form-control" name="questions[]" value="' + $(this).val() + '">');
        });

        elModal.find('.header-sub-text').html(`Are you sure you want to delete all of these items?`);
        elModal.modal('show');
    }

    function deleteBulkAnswerFeedback () {
        let elModal = $('#deleteAnswerFeedback');

        $('.select-answer-feedback:checked').each(function () {
            elModal.find('.feedback-form-group').append('<input type="hidden" class="form-control" name="ids[]" value="' + $(this).val() + '">');
        });

        elModal.find('.header-sub-text').html(`Are you sure you want to remove all of these items?`);
        elModal.modal('show');
    }

    function omitBulkTrainingPhrase () {
        let text = $(this).data('text'),
            elModal = $('#deleteTrainingPhrase');

        elModal.find('.questions-form-group').html('<input type="hidden" class="form-control" name="omit" value="1">');
        $('.select-training-phrases:checked').each(function () {
            let botId = $(this).closest('tr').data('bot-id')
            elModal.find('.questions-form-group').append('<input type="hidden" class="form-control" name="bot_id[]" value="' + botId + '"><input type="hidden" class="form-control" name="questions[]" value="' + $(this).val() + '">');
        });

        elModal.find('.header-sub-text').html(`Are you sure you want to omit all of these items?`);
        elModal.modal('show');
    }

    // This code is required because Bootstrap blocks all focusin calls from elements outside the dialog.
    function tinymceBoostrapAlternativeFix () {
        document.addEventListener('focusin', ( e ) => {
            if (e.target.closest(".tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root") !== null) {
                e.stopImmediatePropagation();
            }
        });
    }

    function languageChange () {
        amplitude.trackLanguageFilter($('#language_selector').val());
        $('#filter_form')[0].submit();
    }

    function handleTrainingPhraseClicked (checkbox, event, isChecked) {
        let elTrainingPhrases = '#training_phrases_table .training-phrase-item .select-training-phrases';

        if (lastTrainingItemChecked && event.shiftKey) {
            let start = $(elTrainingPhrases).index(checkbox);
            let end = $(elTrainingPhrases).index(lastTrainingItemChecked);
            let checkboxesInRange = $(elTrainingPhrases).slice(Math.min(start, end), Math.max(start, end) + 1);

            checkboxesInRange.prop('checked', isChecked);
        }

        lastTrainingItemChecked = checkbox;
    }

    function onChangeTrainingPhrases (e) {
        if ($('.select-training-phrases:checked')[0]) {
            $('.delete-bulk-phrase, .omit-bulk-phrase').removeClass('d-none');
        } else {
            $('.delete-bulk-phrase, .omit-bulk-phrase').addClass('d-none');
        }
    }

    function selectAnswerFeedbacks () {
        if ($('.select-answer-feedback:checked')[0]) {
            $('.delete-bulk-answer-feedback').removeClass('d-none');
        } else {
            $('.delete-bulk-answer-feedback').addClass('d-none');
        }
    }

    function printCss () {
        $('.print-analytics-page-wrapper').css('max-width', '800px');
        $('.print-circular-graph').css('width', '390px');
        $('.print-circular-graph.print-left-20').css('left', '-20px');
        $('.print-circular-graph.print-left-30').css('left', '-30px');
        $('.print-line-graph').css('width', '780px');
    }

    function trainingDistrictBotChange ( e ) {
        let botId = $(this).val();
        $('#training_phrases_table tbody tr').removeClass('d-none');
        if (botId !== 'all') {
            $('#training_phrases_table tbody tr:not([data-bot-id="' + botId + '"])').addClass('d-none');
        }
    }

    function shareTrainingPhrase () {
        let text = $(this).data('text'),
            elModal = $('#shareTrainingPhrase');

        elModal.find('.questions-form-group').html('<input type="hidden" class="form-control" name="questions[]" value="' + text + '">');
        elModal.find('.header-sub-text').html(`Are you sure you want to share <strong>"${ text }"</strong> to their district bot?`);
        elModal.modal('show');
    }

    function initSubdomainFilter() {
        const elSubdomainFilter = $('#subdomain_selector');
        if(elSubdomainFilter.hasClass('select2-ajax')) {
            elSubdomainFilter.select2({
                theme: "bootstrap-5",
                dropdownCssClass: 'searchable-select-dropdown',
                placeholder: 'Subsites',
                ajax: {
                    delay: 500,
                    method: 'POST',
                    url: elSubdomainFilter.data('url'),
                    data: function ( params ) {
                        return {
                            _token: $('[name="csrf-token"]').attr('content'),
                            search: params.term,
                            start_date: $('#start_date').val(),
                            end_date: $('#end_date').val(),
                            language: $('#language_selector').val(),
                        };
                    },
                    processResults: function ( data ) {
                        return {
                            results: data
                        };
                    }
                },
                minimumInputLength: 3
            });
        } else {
            elSubdomainFilter.select2({
                theme: "bootstrap-5",
                width: '100%',
                placeholder: 'Subsites'
            })
        }
    }

    function initEmailReportFields() {
        const $select = $('#emailReportModal .emails-report-field');
        $select.select2({
            tags: true,
            tokenSeparators: [ ',', ' ' ],
            theme: "bootstrap-5",
            placeholder: "Type in email separated by comma or space",
            minimumResultsForSearch: Infinity, // disables search box for normal dropdowns
            dropdownCssClass: 'd-none',        // hides the dropdown
            language: {
                noResults: function ( ) {
                    return '';
                }
            },
            createTag: function ( params ) {
                const term = params.term.trim();
                if (term.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)) {
                    return {
                        id: term,
                        text: term
                    };
                }
                return null;
            }
        });

        // Attach paste event to the inner input field
        // When the Select2 dropdown is opened...
        $select.on('select2:open', function () {

            // Get the actual search input field inside the opened Select2 dropdown
            const $searchInput = $('.select2-container--open .select2-search__field');

            // Remove any existing paste handlers to avoid duplicate bindings
            $searchInput.off('paste').on('paste', function (e) {

                // Prevent the default paste behavior so we can control how the content is handled
                e.preventDefault();

                // Get the text content from the clipboard
                const clipboard = (e.originalEvent || e).clipboardData.getData('text');

                // Split the pasted content by spaces or commas, then filter out any invalid emails
                const emails = clipboard.split(/[\s,]+/).filter(email =>
                    email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)
                );

                // For each valid email, create a new <option> and add it to the Select2 field
                emails.forEach(email => {
                    // Create a new Option (value, text, selected = true, defaultSelected = true)
                    const option = new Option(email, email, true, true);

                    // Append the option to the original select element and trigger a change event
                    $select.append(option).trigger('change');
                });

                // Clear the input field to prevent Select2 from trying to auto-tokenize the pasted text
                $(this).val('');
            });
        });
    }

    function trackAnalyticsLoaded() {
        const eventProperties = {};
        const pageRouteName = $('.page_route').val();

        if ( pageRouteName === 'organizations.bots.analytics' || pageRouteName === 'bots.analytics' || pageRouteName === 'global-bots.analytics' ) {
            eventProperties['always_on_organization_id'] = organizationId;
            eventProperties['always_on_bot_id'] = botId;

            amplitude.trackAnalyticsLoaded('always_on_analytics_loaded_bot_' + botId, eventProperties);
        } else if ( pageRouteName === 'organizations.analytics' ) {
            eventProperties['always_on_organization_id'] = organizationId;
            amplitude.trackAnalyticsLoaded('always_on_analytics_loaded_org_' + organizationId, eventProperties);
        }
    }

    function trackEmailReportSent() {
        if (window.AMPLITUDE_BOOT?.track_email_report_sent) {
            amplitude.trackReportEmailed({
                always_on_organization_id: organizationId,
                always_on_bot_id: botId,
            });
        }
    }

    function triggerAmplitudeEvents() {
        trackAnalyticsLoaded();
        trackEmailReportSent();
    }

    return {
        init: function () {
            lineGraphInit();
            circleGraph();
            circularSessionsPerLanguagesGraph();
            initDatePicker();
            initPopupTraining();
            tinymceBoostrapAlternativeFix();
            initSubdomainFilter();
            initEmailReportFields();
            triggerAmplitudeEvents();


            $('body').on('click', '.assign-to-an-answer', assignToAnAnswer)
                .on('change', '#is_existing', toggleTrainingOptions)
                .on('submit', '#training_form', submitTraining)
                .on('click', '.delete-question', deleteQuestion)
                .on('click', '.delete-training-phrase', deleteTrainingPhrase)
                .on('click', '.delete-answer-feedback', deleteAnswerFeedback)
                .on('click', '.omit-training-phrase', omitTrainingPhrase)
                .on('change', '#language_selector', languageChange)
                .on('change', '#training_district_bot_selector', trainingDistrictBotChange)
                .on('click', '.share-training-phrase', shareTrainingPhrase)
                .on('click', '.training-phrase-item .select-training-phrases', function ( e ) {
                    handleTrainingPhraseClicked(this, e, $(this).is(':checked'));
                })
                .on('click', '.training-phrase-item .form-check-label', function ( e ) {
                    let elCheckbox = $(this).closest('.training-phrase-item').find('.select-training-phrases');
                    handleTrainingPhraseClicked(elCheckbox, e, !elCheckbox.is(':checked'));
                })
                .on('change', '.select-training-phrases', onChangeTrainingPhrases)
                .on('change', '.select-answer-feedback', selectAnswerFeedbacks)
                .on('click', '.delete-bulk-phrase', deleteBulkTrainingPhrase)
                .on('click', '.delete-bulk-answer-feedback', deleteBulkAnswerFeedback)
                .on('click', '.omit-bulk-phrase', omitBulkTrainingPhrase)
                .on('change', '#select_all_training_phrases', function () {
                    $('.select-training-phrases').prop('checked', $(this).is(':checked')).change();
                })
                .on('change', '#filter_form .subdomain-filter [name="subsites[]"]', function () {
                    const el = $(this);
                    el.closest('.subdomain-filter').find('[type="submit"]').removeClass('d-none');
                })
                .on('change', '#select_all_answer_feedback', function () {
                    $('.select-answer-feedback').prop('checked', $(this).is(':checked')).change();
                })
                .on('click', '.print-button', function () {
                    printCss();
                    setTimeout(() => {
                        window.print();
                        amplitude.trackPrint({
                            always_on_organization_id: organizationId,
                            always_on_bot_id: botId,
                        });
                    }, 200);
                })
                .on('click', '.email-report-button', emailReportButton)
                .on('click', '#filter_form .date-filter-button', function ( e ) {
                    const elFilterForm = $('#filter_form');
                    if (elFilterForm.find('[name="start_date"]').val() && elFilterForm.find('[name="end_date"]').val()) {
                        amplitude.trackDatesFiltered(elFilterForm.find('[name="start_date"]').val(), elFilterForm.find('[name="end_date"]').val(), {
                            always_on_organization_id: organizationId,
                            always_on_bot_id: botId,
                        })
                    }
                })
                .on('click', '#filter_form .subsites-filter-button', function ( e ) {
                    const elFilterForm = $('#filter_form');
                    const elSubdomainFilterField = elFilterForm.find('.subdomain-filter [name="subsites[]"]');
                    if (elSubdomainFilterField.val() && elSubdomainFilterField.val().length > 0) {
                        amplitude.trackSubsitesFiltered(elSubdomainFilterField.val(), {
                            always_on_organization_id: organizationId,
                            always_on_bot_id: botId,
                        });
                    }
                })
                .on('click', '#top_questions_list .top-question-toggle', function () {
                    if ($(this).attr('aria-expanded') === 'true') {
                        amplitude.trackTopQuestionExpanded($(this).find('.question-text').text(), {
                            always_on_organization_id: organizationId,
                            always_on_bot_id: botId,
                        });
                    }
                })
                .on('submit', '#filter_form', function ( e ) {
                    e.preventDefault();

                    const elFilterForm = $(this);
                    setTimeout(() => { elFilterForm[0].submit(); }, 100)
                });

            window.onbeforeprint = ( event ) => {
                printCss();
            };

            window.onafterprint = ( event ) => {
                $('.print-analytics-page-wrapper, .print-circular-graph, .print-line-graph').removeAttr('style');
            };
        }
    };

})();

// Provide the route name
App.registerRoute('organizations.analytics', App.BotAnalytics.init);
App.registerRoute('organizations.bots.analytics', App.BotAnalytics.init);
App.registerRoute('bots.analytics', App.BotAnalytics.init);
App.registerRoute('global-bots.analytics', App.BotAnalytics.init);
App.registerRoute('organizations.bots.analytics-print-view', App.BotAnalytics.init);
App.registerRoute('organizations.analytics-print-view', App.BotAnalytics.init);
App.registerRoute('bots.analytics-print-view', App.BotAnalytics.init);

export default App.BotAnalytics;
